var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreditBalance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.0987549,
    width: 36,
    height: 36,
    rx: 8,
    fill: "#D9ECFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1755 10.321C20.1766 9.09321 17.6731 8.09875 14.5883 8.09875C11.5036 8.09875 9.00224 9.09432 9 10.321M9 10.321C9 11.5488 11.5013 12.5432 14.5883 12.5432C17.6753 12.5432 20.1766 11.5488 20.1766 10.321L20.1766 18.9432M9 10.321V23.6544C9.00112 24.8822 11.5024 25.8766 14.5883 25.8766C16.0849 25.8766 17.4361 25.64 18.4387 25.2589M9.00112 14.7655C9.00112 15.9933 11.5025 16.9877 14.5894 16.9877C17.6764 16.9877 20.1778 15.9933 20.1778 14.7655M18.5057 20.7934C17.4976 21.1878 16.115 21.4323 14.5883 21.4323C11.5024 21.4323 9.00112 20.4378 9.00112 19.21M26.5272 19.5634C28.4909 21.5156 28.4909 24.6823 26.5272 26.6346C24.5635 28.5868 21.3781 28.5868 19.4144 26.6346C17.4507 24.6823 17.4507 21.5156 19.4144 19.5634C21.3781 17.6111 24.5635 17.6111 26.5272 19.5634Z",
    stroke: "#007DFA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditBalance);
export default __webpack_public_path__ + "static/media/creditBalance.8199b83f29a38a994d4d054f5522f74a.svg";
export { ForwardRef as ReactComponent };